export default __webpack_public_path__ + "static/media/portfolio-167.a52ea93d.jpg";